module.exports = __webpack_public_path__ + "img/consult_info3.113f229a.png";